import React from "react";
import { Link } from "@sscs/ui";
import styles from "./eulaLink.module.scss";

const EulaLink = (): React.JSX.Element => {
  return (
    <p className={styles["login-eula"]}>
      By logging in, you agree that you have read and accepted the{" "}
      <Link href="./ReversingLabs_MLSA.pdf" target="_blank" inline>
        EULA
      </Link>
    </p>
  );
};

export default EulaLink;
